import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Main } from '../../../modules/Edu/Main/Main';
import { CourseList } from '../../../modules/Edu/CourseList/CourseList';
import { NFTList } from '../../../modules/Edu/NFTList/NFTList';
import { NFTView } from '../../../modules/Edu/NFTView/NFTView';
import { CourseCreation } from '../../../modules/Edu/CourseCreation/CourseCreation';
import { useUserContext } from '../../../providers';
import { CoursePreview } from '../../../modules/Edu/CourseView/CoursePreview';
import { EnrolledCoursePage } from '../../../modules/Edu/EnrolledCoursePage/EnrolledCoursePage';
import { CoursePerformance } from '../../../modules/Edu/CoursePerfomance/CoursePerformance';
import { EduRoutes, MainRoutes } from './types/routes';
import { VerifyCourseList } from '../../../modules/Edu/VerifyCourseList/VerifyCourseList';
import { CourseRejected } from '../../../modules/Edu/CourseRejected/CourseRejected';
import { NFTViewSchool } from '../../../modules/Edu/NFTView/components/NFTViewSchool';
import { LearningProgress } from '../../../modules/Edu/LearningProgress/LearningProgress';

export const EduRouter: React.FC = () => {
  const { user } = useUserContext();

  return (
    <div className="mx-auto w-full grow !pt-24 sm-max:p-2">
      <div className="mx-auto w-full grow">
        <Routes>
          <Route
            path="/"
            element={
              <Navigate to={MainRoutes.edu + EduRoutes['digital-passes']} replace />
            }
          />
          <Route
            path={EduRoutes.courses}
            element={
              <>
                {!user && <Main />}
                {user?.user_type === 'USER' && <Main />}
                {user?.user_type === 'INSTITUTION' && <CourseList />}
              </>
            }
          />
          <Route path={EduRoutes.course + '/:id'} element={<CoursePreview />} />
          <Route path={EduRoutes.enroll + '/:id'} element={<EnrolledCoursePage />} />

          <Route path={EduRoutes['digital-passes']} element={<NFTList />} />
          <Route path={EduRoutes.nft + '/:id'} element={<NFTView />} />
          <Route
            path={EduRoutes.nft + '/:id' + EduRoutes.shcool}
            element={<NFTViewSchool />}
          />

          <Route path={EduRoutes['my-courses']} element={<CourseList />} />
          <Route path={EduRoutes.verify} element={<VerifyCourseList />} />
          <Route path={EduRoutes.edit + '/:id/*'} element={<CourseCreation />} />

          <Route
            path={EduRoutes.preview + '/:id'}
            element={<EnrolledCoursePage isPreview />}
          />
          <Route
            path={EduRoutes.performance + '/:id'}
            element={<CoursePerformance />}
          />
          <Route path={EduRoutes.rejected + '/:id'} element={<CourseRejected />} />
          <Route path={EduRoutes.progress + '/:id'} element={<LearningProgress />} />
        </Routes>
      </div>
    </div>
  );
};
